import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoFeatureGrid } from "@/components/seo/SeoFeatureGrid";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Brain, Users, Heart, Sparkles } from "lucide-react";

const WystepNaIntegracje = () => (
  <SeoPageLayout title="Występ komediowy" titleAccent="na integrację">
    <SeoSection title="Integracja firmowa z humorem">
      <p>Integracja firmowa to nie tylko wyjazd za miasto i kolacja w restauracji. Aby naprawdę zbliżyć do siebie pracowników, potrzebujesz wspólnego, emocjonalnego doświadczenia. Występ komediowy to sprawdzony sposób na przełamanie barier, wspólny śmiech i budowanie relacji, które przetrwają długo po zakończeniu imprezy.</p>
    </SeoSection>

    <SeoSection title="Dlaczego śmiech integruje zespół?">
      <p>Badania psychologiczne potwierdzają, że wspólny śmiech wzmacnia więzi społeczne, obniża poziom stresu i buduje zaufanie. Kiedy ludzie śmieją się razem, tworzą wspólne pozytywne wspomnienia. To naturalny i skuteczny sposób na budowanie kultury organizacyjnej opartej na otwartości i wzajemnym szacunku.</p>
      <SeoHighlightBox icon={Brain}>
        Wspólny śmiech uwalnia endorfiny i oksytocynę - hormony odpowiedzialne za budowanie więzi i zaufania w zespole.
      </SeoHighlightBox>
    </SeoSection>

    <SeoSection title="Formaty występów integracyjnych">
      <SeoFeatureGrid features={[
        { icon: Sparkles, title: "Klasyczny stand-up", description: "Komik wchodzi na scenę i prowadzi solowy występ dopasowany do firmy." },
        { icon: Users, title: "Interaktywny show", description: "Publiczność aktywnie uczestniczy, komik improwizuje z sali." },
        { icon: Heart, title: "Roast firmowy", description: "Żartobliwe, ciepłe komentarze o firmie, zarządzie i codziennych sytuacjach." },
        { icon: Brain, title: "Stand-up + gra/quiz", description: "Połączenie występu z angażującą grą zespołową." },
      ]} />
    </SeoSection>

    <SeoSection title="Jak przygotowujemy materiał integracyjny?">
      <p>Przed każdym występem integracyjnym przeprowadzamy dokładny wywiad z organizatorem. Pytamy o strukturę firmy, kulturę organizacyjną, znane anegdoty i sytuacje, które mogą posłużyć jako materiał komediowy. Dzięki temu występ jest spersonalizowany i trafia prosto w serca publiczności.</p>
    </SeoSection>

    <SeoSection title="Najlepszy moment na występ komediowy podczas integracji">
      <p>Z naszego doświadczenia wynika, że idealnym momentem na występ komediowy jest wieczór pierwszego dnia integracji - po kolacji, gdy atmosfera jest już rozluźniona. Występ może też świetnie otworzyć drugi dzień lub stanowić punkt kulminacyjny jednodniowego eventu.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default WystepNaIntegracje;
